/**
 * Deterministic color palette for campaign blocks.
 *
 * Same input → same output across renders, so the color becomes a visual
 * handle the admin can rely on ("the gold block on Lobby"). When a slot has
 * no real contentId (Phase 8 leak), we fall back to hashing the resolved
 * label string so at least visually-identical campaigns keep one color.
 *
 * Hashes into HUE_BUCKETS evenly-spaced hues on the color wheel and
 * renders in HSL. 36 buckets keeps neighbouring hues distinguishable
 * to the eye while reducing collision probability sharply for typical
 * fleet sizes (≤30 active contents).
 */

const HUE_BUCKETS = 36;
const SATURATION_PCT = 62;
const LIGHTNESS_PCT = 48;

// Hues in these ranges look pale at L=48; darken slightly so they stay
// legible against the timeline's near-white surface.
const PALE_HUE_RANGES = [
  [40, 75],   // yellow → lime
  [165, 200], // pale cyan
];

const hashInt = (str) => {
  let h = 0;
  const s = String(str || '');
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};

const inPaleBand = (hue) =>
  PALE_HUE_RANGES.some(([lo, hi]) => hue >= lo && hue < hi);

export const hashColor = (primary, secondary = '') => {
  const seed = primary && String(primary).length ? primary : secondary;
  const bucket = hashInt(seed) % HUE_BUCKETS;
  const hue = Math.round((bucket * 360) / HUE_BUCKETS);
  const lightness = inPaleBand(hue) ? LIGHTNESS_PCT - 8 : LIGHTNESS_PCT;
  const bg = `hsl(${hue} ${SATURATION_PCT}% ${lightness}%)`;
  const border = `hsl(${hue} ${SATURATION_PCT}% ${Math.max(20, lightness - 18)}%)`;
  return { bg, text: '#ffffff', border };
};
